export default __webpack_public_path__ + "static/media/wone.1dc1b8b4.svg";